import { useEffect, useState, useContext } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import "./Css/GameGallery.css";
import { AppContext } from "../../context/AppContext";
import Advertise from "./Advertise";
import { Helmet } from "react-helmet-async";

function GameWrapper() {
  const adminurl = process.env.REACT_APP_ORIGIN_API;
  const [gameNameData, setGameNameData] = useState([]);
  const [cardsData, setCardsData] = useState([]);
  const [description, setDescription] = useState("");
  const [homeAD, setHomeAD] = useState(true);
  //const [gameList,setGameList] = useState([]);
  const navigate = useNavigate();

  const {
    Backend_folder_path,
    addGameUrl,
    setCategory,
    gameList,
    setgamelist,
    setpagetype,
    setdescreption,
    setgametitle,
    setmetadata,
    setgametype,
    setgameid,
    setappstorelink,
    AppStoreLink,
    metadata,
    setThumbImgStatus,
    setGameIframeStatus,
  } = useContext(AppContext);
  const { addThumbImg } = useContext(AppContext);
  useEffect(() => {
    const envString = process.env.REACT_APP_ALLOWED_DOMAINS;
    const allowedList = envString.split(",").map((domain) => domain.trim());
    const currentHost = window.location.hostname;
    const orginHost =
      process.env.REACT_APP_ORIGIN_HOST || "https://htmlgames4u.com";
    if (!allowedList.includes(currentHost)) {
      window.location.replace(orginHost);
    }
    axios
      .get(`${adminurl}/hello`)
      .then((res) => {
        if (Array.isArray(res.data.message)) {
          setGameNameData(res.data.message);

          toast.success(res.data.message);
        } else {
          //console.error('Expected array, got:', res.data.message);
        }
      })
      .catch((err) => console.error("API error:", err));

    const fetchData = async () => {
      try {
        const res = await axios.get(`${adminurl}/get-game-list`);
        if (res.data.message) {
          setgamelist(res.data.getAllGame);
        } else {
          //console.error('Failed to fetch game list:', res.data.message);
        }
      } catch (err) {
        //console.error('Error fetching game list:', err);
      }
    };

    fetchData();
  }, []);
  useEffect(() => {
    const newCards = gameList.map((game, index) => ({
      title: `${game.game_title}`, // optional formatting
      id: index + 1,
      path: `${Backend_folder_path}${game.folder_path}/index.html`,
      thumb_img: `${Backend_folder_path}${game.thumbnail_img_path}`,
      url: game.url,
      category: game.category,
      description: game.description,
      enable: game.enable,
      title: game.game_title,
      meta_title: game.meta_title,
      meta_keyword: game.meta_keyword,
      meta_description: game.meta_description,
      gameType: game.gameType,
      gameId: game.id,
      iso_link: game.iso_link,
      playstore_link: game.playstore_link,
    }));

    setCardsData(newCards);
  }, [gameList]);
  const handleClick = (game) => {
    setThumbImgStatus(true);
    setGameIframeStatus(false);
    const url = game.url;
    addGameUrl(game.path);
    addThumbImg(game.thumb_img);
    setCategory(game.category);
    setpagetype("gamePage");
    setgametitle(game.title);
    setdescreption(game.description);

    const gameTypeArray = game.gameType.split(",").map((item) => item.trim());

    setgametype(gameTypeArray);
    setgameid(game.gameId);

    setmetadata({
      title: game.meta_title,
      keywords: game.meta_keyword,
      descreption: game.meta_description,
    });
    setappstorelink({
      ...AppStoreLink,
      iso_link: game.iso_link,
      playstore_link: game.playstore_link,
    });
    const titleTag = document.querySelector("head > title");
    titleTag.textContent = game.title
      .replace(/-/g, " ")
      .replace(/\b\w/g, (char) => char.toUpperCase());

    navigate(`/game/${url}`);

    setTimeout(() => {
      window.scrollTo({ top: "59", behavior: "smooth" });
    }, 100);
  };

  return (
    <>
      <Helmet>
        <meta
          name="title"
          content="Free HTML5 Games for Kids & Adults | Play Online at HTMLGames4U"
        />
        <meta
          name="description"
          content="Play free HTML5 games online for kids and adults. Fun, safe, and no download required. Enjoy puzzle, arcade, and educational games now!"
        />
        <meta
          name="keywords"
          content="free HTML5 games, play HTML5 games online, HTML5 games for kids, HTML5 games for adults, no download games, online puzzle games, free arcade games online, educational HTML5 games, fun online games, safe online games, best HTML5 puzzle games online, browser games free, mobile-friendly online games"
        />
      </Helmet>
      <div className="gallery-container">
        <h1 style={{ fontSize: "14px" }}>
          Free Online Games - <span>htmlgames4u.com</span>
        </h1>
        <div className="game-grid" style={{ marginTop: "10px" }}>
          {cardsData.length > 10 ? (
            cardsData.map(
              (game) =>
                game.enable && (
                  <div
                    style={{ cursor: "pointer" }}
                    className="game-card"
                    key={game.id}
                  >
                    <img
                      onClick={() => handleClick(game)}
                      src={game.thumb_img}
                      alt={game.title}
                    />
                    <div className="game-title">{game.title}</div>
                  </div>
                )
            )
          ) : (
            <div
              style={{ height: "230px", textAlign: "center", color: "gray" }}
            >
              {" "}
              loading...
            </div>
          )}
        </div>
        {homeAD && (
          <div style={{ marginTop: "10px" }}>
            <Advertise slot="4024810141" width="98%" />
          </div>
        )}

        <Outlet />
      </div>

      {/* <Category /> */}
    </>
  );
}

export default GameWrapper;
